import type { Item } from '@/components/SelectFieldComp';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';
import { ABSENCE_REASONS, type AbsenceReasonType } from '@/types/domain/attendContact/valueObjects/absenceReason';

/**
 * 欠席理由
 */
export class AbsenceReason extends PrimitiveValueObject<AbsenceReasonType> {
  /**
   * 作成
   * @param props プロパティ
   * @returns アイテム
   */
  static create(props: AbsenceReasonType): AbsenceReason {
    return new AbsenceReason(props);
  }

  /** ラベル */
  static get label(): string {
    return '理由';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** アイテム一覧 */
  static get items(): {
    /** ID */
    id: string,
    /** 名前 */
    name: string,
  }[] {
    const items: Item[] = [];
    for (let i = 0; i < ABSENCE_REASONS.length; i += 1) {
      items.push({
        id: ABSENCE_REASONS[i],
        name: ABSENCE_REASONS[i],
      });
    }
    return items;
  }
}
